import { useMemo } from "react";
import { useUsersMap } from "@tellescope/tanstack-query";
import type { ChatMessage } from "@tellescope/types-models";
import { useEnduserCurrentEnduser } from "../store/hooks";

export interface UseChatMessageSendersOptions {
  messages: ChatMessage[];
}

export const collectSenderIds = (messages: ChatMessage[], excludeId?: string): string[] => {
  const ids = new Set<string>();
  for (const message of messages) {
    if (message.senderId && message.senderId !== excludeId) {
      ids.add(message.senderId);
    }
  }
  return [...ids].sort();
};

/**
 * Resolves the care-team User records for the senders of the given chat
 * messages. Sender ids belonging to the current enduser (or other endusers in
 * a group room) won't match a user and are simply absent from the map.
 */
export const useChatMessageSenders = ({ messages }: UseChatMessageSendersOptions) => {
  const currentEnduser = useEnduserCurrentEnduser();

  const senderIds = useMemo(() => collectSenderIds(messages, currentEnduser?.id), [messages, currentEnduser?.id]);

  const sendersById = useUsersMap(senderIds);

  return { sendersById };
};
